/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class SitemapService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get sitemap
     * @returns any The sitemap has been successfully generated.
     * @throws ApiError
     */
    public siteMapControllerGetSitemap(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/sitemap',
        });
    }
}
